export default "__VITE_ASSET__hoojxdNU__"